import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToasterComponent } from '@welma-education/ui/sonner';

@Component({
  selector: 'lgs-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, ToasterComponent],
})
export class AppComponent {}
